import {popUpType} from "./slice";
import {types} from "./types";

export const setPopUpFields = (data: Partial<popUpType>) => {
    return {type: types.SET_VALUES, payload: data}
}